import { mapState } from 'vuex';
import _ from 'lodash';
import moment from 'moment';

export default {
    mounted() {
        if (this.localSearchParams) {
            this.form = _.cloneDeep(this.localSearchParams);
            this.form.sort &&
                typeof this.form.sort === 'string' &&
                (this.form.sort = _.find(this.sort, { by: this.form.sort }));
        }
    },
    watch: {
        form: {
            handler(form) {
                form &&
                    this.$store.dispatch('setSearchParams', {
                        key: this.$route.path,
                        value: {
                            ...form,
                            sort: form.sort && form.sort.by,
                            date: form.date && moment(form.date).format('YYYY-MM-DD'),
                        },
                    });
            },
            deep: true,
        },
    },
    computed: {
        ...mapState({
            searchParams: state => state.lists.searchParams,
        }),
        localSearchParams() {
            return this.searchParams[this.$route.path];
        },
    },
};
